// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".shared-step-editor-input-counter[data-v-31aff496]{all:unset;display:inline-block;font-size:12px;text-align:right;width:100%;color:#8e97ab;font-size:11px}", ""]);
// Exports
module.exports = exports;
